import React from 'react'
import useFormValidation from "../../components/auth/useFormValidation";
import validateCreateCiclo from "../../components/auth/validateCreateCiclo";
import FirebaseContext from "../../firebase/context";

import { Button, TextField, TableRow, TableCell } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';

const INITIAL_STATE = {
    tituloCiclo: "",
};

const CompCicloListAdd = ({ props, setShowCicloFormAdd }) => {

    const { firebase, user } = React.useContext(FirebaseContext);
    const { handleSubmit, handleChange, values, errors } = useFormValidation(
        INITIAL_STATE,
        validateCreateCiclo,
        handleCreateCiclo
    );

    function handleCreateCiclo() {
        if (!user) {
            props.history.push("/login");
        } else {
            const { tituloCiclo } = values;
            const newLink = {
                tituloCiclo,
            };
            firebase.db.collection("colCiclos").add(newLink);
            setShowCicloFormAdd(false);
        }
    }

    return (
        <React.Fragment>
            <TableRow >
                <TableCell align='justify'>
                    <form onSubmit={handleSubmit} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Titulo de Ciclo"
                            name="tituloCiclo"
                            margin="normal"
                            placeholder="Titulo de Ciclo"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.tituloCiclo && "error-input"}
                            value={values.tituloCiclo}
                        />
                        {errors.tituloCiclo && <p className="error-text">{errors.tituloCiclo}</p>}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="submit"
                            startIcon={<SaveIcon />}
                        >
                            GUARDAR
                               </Button>
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            type="button"
                            onClick={() => setShowCicloFormAdd(false)}
                            startIcon={<CancelIcon />}
                        >
                            CANCELAR
                               </Button>

                    </form>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default CompCicloListAdd
